<template>
  <div class="editor">
    <div class="editor-body">
      <image-content
        v-if="showTabContent"
        :styles="part.styles"
        :attrs="part.attrs"
        :ids="ids"
        :partsContainerType="partsContainerType"
      />
      <image-style
        v-if="showTabStyle"
        :part="part"
        :ids="ids"
        :partsContainerType="partsContainerType"
        :partsContainerStyles="partsContainerStyles"
      />
      <edit-parts-container-style
        v-if="showTabSetting"
        :styles="partsContainerStyles"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partsContainerType="partsContainerType"
      />
    </div>
  </div>
</template>

<script>
import EditPartsContainerStyle from '@/components/Content/Palette/EditPartDesign/Layouts/PartsContainerStyle'
import ImageContent from '@/components/Content/Palette/EditPartDesign/Editor/Image/ImageContent'
import ImageStyle from '@/components/Content/Palette/EditPartDesign/Editor/Image/ImageStyle'

const initialData = () => {
  return {
    currentTab: 'Content',
  }
}

export default {
  props: [
    'current',
    'part',
    'partsContainerId',
    'sectionId',
    'partsContainerType',
    'partsContainerStyles',
  ],
  components: {
    EditPartsContainerStyle,
    ImageContent,
    ImageStyle,
  },
  data () {
    return initialData()
  },
  computed: {
    showTabContent () {
      // コードパーツの場合はTag
      return this.current.tab === 'Content' || this.current.tab === 'Tag'
    },
    showTabStyle () {
      return this.current.tab === 'Style'
    },
    showTabSetting () {
      return this.current.tab === 'Setting'
    },
    ids () {
      return {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.part.id
      }
    },
  },
  watch: {
    partsContainerId (value) {
      Object.assign(this.$data, initialData())
    },
  }
}
</script>

<style lang="scss" scoped>
.editor {
  color: $commonFontColor;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .editor-body {
    width: 100%;
  }
}
</style>
